// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/Montserrat-ExtraBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/Poppins-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/Poppins-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../images/signup/signup-bg.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Montserrat-ExtraBold";
  src: local("Montserrat-ExtraBold"), url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
}
@font-face {
  font-family: "Poppins-Regular";
  src: local("Poppins-Regular"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
}
@font-face {
  font-family: "Poppins-Bold";
  src: local("Poppins-Bold"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
}
.required-color {
  color: red;
}

body {
  margin: 0;
}

.fa-chevron-right:before {
  content: "\\f054";
  font: normal normal normal 14px/1 FontAwesome;
  padding: 8px;
  position: relative;
  top: 0px;
}

.fa-chevron-left:before {
  font: normal normal normal 14px/1 FontAwesome;
}

body {
  overflow-x: hidden;
}

a:focus,
a:hover {
  color: #000;
  text-decoration: none;
  outline: 0;
}

a {
  color: #000;
  font-family: "Poppins-Regular";
  text-decoration: unset;
}

a:active,
a:focus {
  outline: 0;
  border: none;
  -moz-outline-style: none;
}

img {
  max-width: 100%;
}

.row {
  margin: 0;
  padding: 0;
}

ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

li {
  color: #000;
  font-weight: 300;
  font-family: "Poppins-Regular";
}

p strong {
  font-size: 20px;
  font-family: "Poppins-Regular";
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Poppins-Bold";
}

.no-margin {
  margin: 0;
}

p,
span {
  font-family: "Poppins-Regular";
}

.container-fluid {
  padding: 0;
}

img {
  max-width: 100%;
}

.container {
  padding: 0;
  max-width: 1260px;
  margin: 0 auto;
  width: auto;
}

a h4:hover {
  opacity: 0.8;
}

.svg {
  position: absolute;
  width: 0;
  height: 0;
}

.slick-initialized .slick-slide {
  outline: unset;
}

.signuppage_wrapper {
  float: left;
  width: 100%;
  padding: 5em 0 3em;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.signuppage_left_content {
  display: flex;
  align-items: center;
  margin: 3em 0;
}

.signuppage_left_content_image {
  width: 50%;
}

.signuppage_left_part h1 {
  font-size: 50px;
  background-image: linear-gradient(to left, #088182, #088182, #088182, #088182, #354959, #354959, #354959);
  -webkit-background-clip: text;
  -moz-background-clip: text;
  background-clip: text;
  color: transparent;
  margin: 0.5em 0;
}

.signuppage_left_box h4 {
  font-size: 20px;
  color: #354959;
  font-family: "Poppins-Bold";
}

.signuppage_left_box p {
  font-size: 16px;
  line-height: 24px;
  color: #354959;
}

.signuppage_right_part {
  float: right;
  border-radius: 25px;
  filter: drop-shadow(6px 10.392px 14.5px rgba(0, 0, 0, 0.1));
  background-color: #fff;
  padding: 3em 5em;
  text-align: center;
}

.signuppage_right_part .form-group label {
  font-size: 16px;
  color: #354959;
  font-family: "Poppins-Regular";
  font-weight: 400;
}

.signuppage_right_part .form-group .form-control {
  height: 47px;
  border-radius: 10px;
  border: 1px solid rgba(0, 146, 159, 0.1490196078);
  font-family: "Poppins-Regular";
  color: #354959;
  font-size: 16px;
  padding: 0 30px;
}

#form_cancel {
  border-radius: 10px;
  background-color: #f1f2f3;
  font-size: 20px;
  letter-spacing: 0px;
  color: rgba(53, 73, 89, 0.4509803922);
  font-family: "Poppins-Regular";
  width: 50%;
  height: 46px;
  outline: unset;
  border: unset;
}

#form_signup {
  border-radius: 10px;
  background-color: #3c7546;
  font-size: 20px;
  letter-spacing: 0px;
  color: #fff;
  font-family: "Poppins-Regular";
  width: 50%;
  height: 46px;
  outline: unset;
  border: unset;
}

.signup_btn {
  display: flex;
  margin-top: 20px;
  gap: 30px;
}

.ul-tag ul {
  list-style-type: circle;
  padding: 20px;
  margin-bottom: 10px;
  margin-left: 20px;
}

.bg-dark-green {
  background-color: #335539 !important;
}

@media only screen and (max-width: 1300px) {
  .container {
    padding: 0 15px;
  }
}
@media only screen and (max-width: 1200px) {
  .signuppage_left_box {
    padding-left: 10px;
  }
  .signuppage_right_part {
    padding: 2em 2em;
  }
}
@media only screen and (max-width: 992px) {
  .signuppage_section {
    display: block;
  }
  .signuppage_left_part {
    width: 100%;
  }
  .signuppage_right_part {
    width: 100%;
    margin: 2em 0 1em;
  }
  .signuppage_left_content_image {
    width: auto;
  }
  .signuppage_left_part h1 {
    font-size: 40px;
  }
  .signuppage_left_content {
    margin: 1em 0;
  }
  .signuppage_right_part {
    padding: 2em 1em;
  }
  .signuppage_section.login_page .signuppage_right_part {
    padding: 5em 1em 3em;
  }
  .signuppage_right_part ul li a {
    font-size: 16px;
  }
  .signuppage_right_part h2 {
    font-size: 40px;
  }
  .signuppage_wrapper {
    padding: 2em 0 3em;
  }
}`, "",{"version":3,"sources":["webpack://./src/css/custom.scss"],"names":[],"mappings":"AAAA;EACI,mCAAA;EACA,8FAAA;AACJ;AAEA;EACI,8BAAA;EACA,yFAAA;AAAJ;AAGA;EACI,2BAAA;EACA,sFAAA;AADJ;AAaA;EACI,UAAA;AAXJ;;AAcA;EACI,SAAA;AAXJ;;AAcA;EACI,gBAAA;EACA,6CAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;AAXJ;;AAcA;EACI,6CAAA;AAXJ;;AAcA;EACI,kBAAA;AAXJ;;AAiBA;;EAEI,WAnCc;EAoCd,qBAAA;EACA,UAAA;AAdJ;;AAiBA;EACI,WAzCc;EA0Cd,8BA5Ca;EA6Cb,sBAAA;AAdJ;;AAiBA;;EAEI,UAAA;EACA,YAAA;EACA,wBAAA;AAdJ;;AAiBA;EACI,eAAA;AAdJ;;AAiBA;EACI,SAAA;EACA,UAAA;AAdJ;;AA+BA;EACI,qBAAA;EACA,UAAA;EACA,SAAA;AA5BJ;;AA+BA;EAEI,WApFc;EAqFd,gBAAA;EACA,8BAxFa;AA2DjB;;AAgCA;EACI,eAAA;EACA,8BA7Fa;AAgEjB;;AAgCA;;;;;;EAMI,2BArGe;AAwEnB;;AA+BA;EACI,SAAA;AA5BJ;;AA+BA;;EAEI,8BA9Ga;AAkFjB;;AA+BA;EACI,UAAA;AA5BJ;;AA+BA;EACI,eAAA;AA5BJ;;AA+BA;EACI,UAAA;EACA,iBAAA;EACA,cAAA;EACA,WAAA;AA5BJ;;AA+BA;EACI,YAAA;AA5BJ;;AA+BA;EACI,kBAAA;EACA,QAAA;EACA,SAAA;AA5BJ;;AA+BA;EACI,cAAA;AA5BJ;;AA+BA;EACI,WAAA;EACA,WAAA;EACA,kBAAA;EACA,yDAAA;EACA,2BAAA;EACA,4BAAA;EACA,0BAAA;AA5BJ;;AA+BA;EACI,aAAA;EACA,mBAAA;EACA,aAAA;AA5BJ;;AA+BA;EACI,UAAA;AA5BJ;;AA+BA;EACI,eAAA;EACA,yGAhKW;EAiKX,6BAAA;EACA,0BAAA;EACA,qBAAA;EACA,kBAAA;EACA,eAAA;AA5BJ;;AA+BA;EACI,eAAA;EACA,cAzKa;EA0Kb,2BA9Ke;AAkJnB;;AA+BA;EACI,eAAA;EACA,iBAAA;EACA,cAhLa;AAoJjB;;AA+BA;EACI,YAAA;EACA,mBAAA;EACA,2DAAA;EACA,sBAzLc;EA0Ld,gBAAA;EACA,kBAAA;AA5BJ;;AAgCA;EACI,eAAA;EACA,cA/La;EAgMb,8BArMa;EAsMb,gBAAA;AA7BJ;;AAgCA;EACI,YAAA;EACA,mBAAA;EACA,iDAAA;EACA,8BAAA;EACA,cAzMa;EA0Mb,eAAA;EACA,eAAA;AA7BJ;;AAgCA;EACI,mBAAA;EACA,yBAAA;EACA,eAAA;EACA,mBAAA;EACA,qCAAA;EACA,8BAAA;EACA,UAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;AA7BJ;;AAgCA;EACI,mBAAA;EACA,yBA5NU;EA6NV,eAAA;EACA,mBAAA;EACA,WAlOc;EAmOd,8BAAA;EACA,UAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;AA7BJ;;AAgCA;EACI,aAAA;EACA,gBAAA;EACA,SAAA;AA7BJ;;AAgCA;EACI,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;AA7BJ;;AA+BA;EACI,oCAAA;AA5BJ;;AA+BA;EACI;IACI,eAAA;EA5BN;AACF;AA+BA;EACI;IACI,kBAAA;EA7BN;EAgCE;IACI,gBAAA;EA9BN;AACF;AAiCA;EACI;IACI,cAAA;EA/BN;EAkCE;IACI,WAAA;EAhCN;EAmCE;IACI,WAAA;IACA,iBAAA;EAjCN;EAoCE;IACI,WAAA;EAlCN;EAqCE;IACI,eAAA;EAnCN;EAsCE;IACI,aAAA;EApCN;EAuCE;IACI,gBAAA;EArCN;EAwCE;IACI,oBAAA;EAtCN;EAyCE;IACI,eAAA;EAvCN;EA0CE;IACI,eAAA;EAxCN;EA2CE;IAEI,kBAAA;EA1CN;AACF","sourcesContent":["@font-face {\r\n    font-family: 'Montserrat-ExtraBold';\r\n    src: local('Montserrat-ExtraBold'), url(\"../fonts/Montserrat-ExtraBold.ttf\") format('truetype');\r\n}\r\n\r\n@font-face {\r\n    font-family: 'Poppins-Regular';\r\n    src: local('Poppins-Regular'), url(\"../fonts/Poppins-Regular.ttf\") format('truetype');\r\n}\r\n\r\n@font-face {\r\n    font-family: 'Poppins-Bold';\r\n    src: local('Poppins-Bold'), url(\"../fonts/Poppins-Bold.ttf\") format('truetype');\r\n}\r\n\r\n$iboostfont-one: 'Montserrat-ExtraBold';\r\n$iboostfont-two: 'Poppins-Regular';\r\n$iboostfont-three: 'Poppins-Bold';\r\n$iboostclr-black: #000;\r\n$iboostclr-white: #fff;\r\n$iboostbg-clr: linear-gradient(to left, #088182, #088182, #088182, #088182, #354959, #354959, #354959);\r\n$iboosttext-clr: #354959;\r\n$iboost-link: #3c7546\r\n;\r\n.required-color{\r\n    color:red\r\n}\r\n\r\nbody {\r\n    margin: 0;\r\n}\r\n\r\n.fa-chevron-right:before {\r\n    content: \"\\f054\";\r\n    font: normal normal normal 14px/1 FontAwesome;\r\n    padding: 8px;\r\n    position: relative;\r\n    top: 0px;\r\n}\r\n\r\n.fa-chevron-left:before {\r\n    font: normal normal normal 14px/1 FontAwesome;\r\n}\r\n\r\nbody {\r\n    overflow-x: hidden;\r\n}\r\n\r\n// i {\r\n//     font: normal normal normal 14px/1 FontAwesome;\r\n// }\r\na:focus,\r\na:hover {\r\n    color: $iboostclr-black;\r\n    text-decoration: none;\r\n    outline: 0;\r\n}\r\n\r\na {\r\n    color: $iboostclr-black;\r\n    font-family: $iboostfont-two;\r\n    text-decoration: unset;\r\n}\r\n\r\na:active,\r\na:focus {\r\n    outline: 0;\r\n    border: none;\r\n    -moz-outline-style: none;\r\n}\r\n\r\nimg {\r\n    max-width: 100%;\r\n}\r\n\r\n.row {\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n\r\n// .col-sm-1,\r\n// .col-sm-10,\r\n// .col-sm-11,\r\n// .col-sm-12,\r\n// .col-sm-2,\r\n// .col-sm-3,\r\n// .col-sm-4,\r\n// .col-sm-5,\r\n// .col-sm-6,\r\n// .col-sm-7,\r\n// .col-sm-8,\r\n// .col-sm-9 {\r\n//     padding: 0;\r\n// }\r\nul {\r\n    list-style-type: none;\r\n    padding: 0;\r\n    margin: 0;\r\n}\r\n\r\nli {\r\n    // list-style-type: disc;\r\n    color: $iboostclr-black;\r\n    font-weight: 300;\r\n    font-family: $iboostfont-two;\r\n}\r\n\r\np strong {\r\n    font-size: 20px;\r\n    font-family: $iboostfont-two;\r\n}\r\n\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6 {\r\n    font-family: $iboostfont-three;\r\n}\r\n.no-margin {\r\n    margin: 0;\r\n}\r\n\r\np,\r\nspan {\r\n    font-family: $iboostfont-two;\r\n}\r\n\r\n.container-fluid {\r\n    padding: 0;\r\n}\r\n\r\nimg {\r\n    max-width: 100%;\r\n}\r\n\r\n.container {\r\n    padding: 0;\r\n    max-width: 1260px;\r\n    margin: 0 auto;\r\n    width: auto;\r\n}\r\n\r\na h4:hover {\r\n    opacity: 0.8;\r\n}\r\n\r\n.svg {\r\n    position: absolute;\r\n    width: 0;\r\n    height: 0;\r\n}\r\n\r\n.slick-initialized .slick-slide {\r\n    outline: unset;\r\n}\r\n\r\n.signuppage_wrapper {\r\n    float: left;\r\n    width: 100%;\r\n    padding: 5em 0 3em;\r\n    background-image: url(../images/signup/signup-bg.jpg);\r\n    background-position: center;\r\n    background-repeat: no-repeat;\r\n    background-size: 100% 100%;\r\n}\r\n\r\n.signuppage_left_content {\r\n    display: flex;\r\n    align-items: center;\r\n    margin: 3em 0;\r\n}\r\n\r\n.signuppage_left_content_image {\r\n    width: 50%;\r\n}\r\n\r\n.signuppage_left_part h1 {\r\n    font-size: 50px;\r\n    background-image: $iboostbg-clr;\r\n    -webkit-background-clip: text;\r\n    -moz-background-clip: text;\r\n    background-clip: text;\r\n    color: transparent;\r\n    margin: 0.5em 0;\r\n}\r\n\r\n.signuppage_left_box h4 {\r\n    font-size: 20px;\r\n    color: $iboosttext-clr;\r\n    font-family: $iboostfont-three;\r\n}\r\n\r\n.signuppage_left_box p {\r\n    font-size: 16px;\r\n    line-height: 24px;\r\n    color: $iboosttext-clr;\r\n}\r\n\r\n.signuppage_right_part {\r\n    float: right;\r\n    border-radius: 25px;\r\n    filter: drop-shadow(6px 10.392px 14.5px rgba(0, 0, 0, 0.1));\r\n    background-color: $iboostclr-white;\r\n    padding: 3em 5em;\r\n    text-align: center;\r\n}\r\n\r\n\r\n.signuppage_right_part .form-group label {\r\n    font-size: 16px;\r\n    color: $iboosttext-clr;\r\n    font-family: $iboostfont-two;\r\n    font-weight: 400;\r\n}\r\n\r\n.signuppage_right_part .form-group .form-control {\r\n    height: 47px;\r\n    border-radius: 10px;\r\n    border: 1px solid #00929f26;\r\n    font-family: 'Poppins-Regular';\r\n    color: $iboosttext-clr;\r\n    font-size: 16px;\r\n    padding: 0 30px;\r\n}\r\n\r\n#form_cancel {\r\n    border-radius: 10px;\r\n    background-color: #f1f2f3;\r\n    font-size: 20px;\r\n    letter-spacing: 0px;\r\n    color: #35495973;\r\n    font-family: 'Poppins-Regular';\r\n    width: 50%;\r\n    height: 46px;\r\n    outline: unset;\r\n    border: unset;\r\n}\r\n\r\n#form_signup {\r\n    border-radius: 10px;\r\n    background-color: $iboost-link;\r\n    font-size: 20px;\r\n    letter-spacing: 0px;\r\n    color: $iboostclr-white;\r\n    font-family: 'Poppins-Regular';\r\n    width: 50%;\r\n    height: 46px;\r\n    outline: unset;\r\n    border: unset;\r\n}\r\n\r\n.signup_btn {\r\n    display: flex;\r\n    margin-top: 20px;\r\n    gap: 30px;\r\n}\r\n\r\n.ul-tag ul{\r\n    list-style-type: circle;\r\n    padding: 20px;\r\n    margin-bottom: 10px;\r\n    margin-left: 20px;\r\n}\r\n.bg-dark-green {\r\n    background-color:#335539  !important;\r\n    // background-color: #064420 !important; /* Dark Green */\r\n  }\r\n@media only screen and (max-width: 1300px) {\r\n    .container {\r\n        padding: 0 15px;\r\n    }\r\n}\r\n\r\n@media only screen and (max-width: 1200px) {\r\n    .signuppage_left_box {\r\n        padding-left: 10px;\r\n    }\r\n\r\n    .signuppage_right_part {\r\n        padding: 2em 2em;\r\n    }\r\n}\r\n\r\n@media only screen and (max-width: 992px) {\r\n    .signuppage_section {\r\n        display: block;\r\n    }\r\n\r\n    .signuppage_left_part {\r\n        width: 100%;\r\n    }\r\n\r\n    .signuppage_right_part {\r\n        width: 100%;\r\n        margin: 2em 0 1em;\r\n    }\r\n\r\n    .signuppage_left_content_image {\r\n        width: auto;\r\n    }\r\n\r\n    .signuppage_left_part h1 {\r\n        font-size: 40px;\r\n    }\r\n\r\n    .signuppage_left_content {\r\n        margin: 1em 0;\r\n    }\r\n\r\n    .signuppage_right_part {\r\n        padding: 2em 1em;\r\n    }\r\n\r\n    .signuppage_section.login_page .signuppage_right_part {\r\n        padding: 5em 1em 3em;\r\n    }\r\n\r\n    .signuppage_right_part ul li a {\r\n        font-size: 16px;\r\n    }\r\n\r\n    .signuppage_right_part h2 {\r\n        font-size: 40px;\r\n    }\r\n\r\n    .signuppage_wrapper {\r\n\r\n        padding: 2em 0 3em;\r\n    }\r\n\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
